import { ProjectMethodologyEnum } from 'gql/graphql';

export const methodologyLabels: Record<ProjectMethodologyEnum, string> = {
    UER: 'УЕР',
    BIM: 'БИМ',
    ETR: 'ЕТР',
    NONE: '',
};

export const getMethodologyLabel = (methodologyId: ProjectMethodologyEnum) => methodologyLabels[methodologyId];

export const methodologyMap = {
    [ProjectMethodologyEnum.Uer]: 'uer',
    [ProjectMethodologyEnum.Bim]: 'bim',
    [ProjectMethodologyEnum.Etr]: 'etr',
    [ProjectMethodologyEnum.None]: 'none',
};

export const methodologyMapReverse: { [key: string]: ProjectMethodologyEnum } = {
    uer: ProjectMethodologyEnum.Uer,
    bim: ProjectMethodologyEnum.Bim,
    etr: ProjectMethodologyEnum.Etr,
    none: ProjectMethodologyEnum.None,
};
